import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var d = {
  name: "ug-cn",
  weekdays: "يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),
  months: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
  weekStart: 1,
  weekdaysShort: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
  monthsShort: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
  weekdaysMin: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "YYYY-يىلىM-ئاينىڭD-كۈنى",
    LLL: "YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
    LLLL: "dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"
  },
  relativeTime: {
    future: "%s كېيىن",
    past: "%s بۇرۇن",
    s: "نەچچە سېكونت",
    m: "بىر مىنۇت",
    mm: "%d مىنۇت",
    h: "بىر سائەت",
    hh: "%d سائەت",
    d: "بىر كۈن",
    dd: "%d كۈن",
    M: "بىر ئاي",
    MM: "%d ئاي",
    y: "بىر يىل",
    yy: "%d يىل"
  }
};
t.locale(d, null, !0);
export {
  d as default
};
